import Vue from 'vue'
import Router from 'vue-router'

//Pages
import Home from '../pages/Home/Home/Router'
import MinhaConta from '../pages/Inicio/MinhaConta/Router'
import Logs from '../pages/Logs/Logs/Router'

import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Router'
import Usuarios from '../pages/Admin/Usuarios/Router'
import LinhaDoTempo from '../pages/Site/LinhaDoTempo/Router'
import Gestoes from '../pages/Site/Gestoes/Router'
import Multimidias from '../pages/Site/Multimidias/Router'
import Noticias from '../pages/Site/Noticias/Router'
import Paginas from '../pages/Site/Paginas/Router'
import Portfolio from '../pages/Site/Portfolio/Router'
import GovernancaEGestao from '../pages/Site/GovernancaEGestao/Router'

import Redirect from '../pages/redirect/Index/Router'
import Acessar from '../pages/Login/Acessar/Router'
import Erro from '../pages/Erro/404/Router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		...Redirect,
		{
			path: '/',
			component: () => import('@/layouts/Default'),
			children: [
				...Home,
				...MinhaConta,
				...Logs,
				...GrupoDeAcesso,
				...Usuarios,
				...LinhaDoTempo,
				...Gestoes,
				...Multimidias,
				...Noticias,
				...Paginas,
				...Portfolio,
				...GovernancaEGestao,
			]
		},
		...Acessar,
		...Erro,
	]
})